export default "__VITE_ASSET__Ct1umj0A__"